{
  "MESSAGE_STATUS__YESTERDAY": "Hier",
  "CHANNEL__MESSAGE_LIST__NOTIFICATION__NEW_MESSAGE": "Nouveau(x) message(s) depuis",
  "CHANNEL__MESSAGE_LIST__NOTIFICATION__ON": "sur",
  "CHANNEL_PREVIEW_MOBILE_LEAVE": "Quitter la conversation",
  "CHANNEL_SETTING__HEADER__TITLE": "Détails de la conversation",
  "CHANNEL_SETTING__PROFILE__EDIT": "Modifier",
  "CHANNEL_SETTING__MEMBERS__TITLE": "Membres",
  "CHANNEL_SETTING__MEMBERS__SEE_ALL_MEMBERS": "Tous les membres",
  "CHANNEL_SETTING__MEMBERS__INVITE_MEMBER": "Inviter un utilisateur",
  "CHANNEL_SETTING__MEMBERS__YOU": "(Vous)",
  "CHANNEL_SETTING__MEMBERS__SELECT_TITLE": "Sélectionner des utilisateurs",
  "CHANNEL_SETTING__MEMBERS__OPERATOR": "Opérateur",
  "CHANNEL_SETTING__LEAVE_CHANNEL__TITLE": "Quitter la conversation",
  "CHANNEL_SETTING__OPERATORS__TITLE": "Opérateurs",
  "CHANNEL_SETTING__OPERATORS__TITLE_ALL": "Tous les opérateurs",
  "CHANNEL_SETTING__OPERATORS__TITLE_ADD": "Ajouter un opérateur",
  "CHANNEL_SETTING__OPERATORS__ADD_BUTTON": "Ajouter un opérateur",
  "CHANNEL_SETTING__MUTED_MEMBERS__TITLE": "Membres en sourdine",
  "CHANNEL_SETTING__MUTED_MEMBERS__TITLE_ALL": "Tous les membres en sourdine",
  "CHANNEL_SETTING__NO_UNMUTED": "Pas encore de membre en sourdine",
  "CHANNEL_SETTING__BANNED_MEMBERS__TITLE": "Utilisateurs bannis",
  "CHANNEL_SETTING__FREEZE_CHANNEL": "Geler la conversation",
  "CHANNEL_SETTING__MODERATION__REGISTER_AS_OPERATOR": "Enregistrer en tant qu'opérateur",
  "CHANNEL_SETTING__MODERATION__UNREGISTER_OPERATOR": "Enlever en tant qu'opérateur",
  "CHANNEL_SETTING__MODERATION__MUTE": "Mettre en sourdine",
  "CHANNEL_SETTING__MODERATION__UNMUTE": "Ne plus mettre en sourdine",
  "CHANNEL_SETTING__MODERATION__BAN": "Bannir",
  "CHANNEL_SETTING__MODERATION__UNBAN": "Débannir",
  "CHANNEL_SETTING__MODERATION__EMPTY_BAN": "Pas encore de membres bannis",
  "CHANNEL_SETTING__MODERATION__ALL_BAN": "Tous les membres bannis",
  "OPEN_CHANNEL_CONVERSATION__TITLE_PARTICIPANTS": "participants",
  "OPEN_CHANNEL_CONVERSATION__SELECT_PARTICIPANTS": "Sélectionner des participants",
  "OPEN_CHANNEL_LIST__TITLE": "Conversations",
  "CREATE_OPEN_CHANNEL_LIST__TITLE": "Nouveau profil de conversation",
  "CREATE_OPEN_CHANNEL_LIST__SUBTITLE__IMG_SECTION": "Photo de la conversation",
  "CREATE_OPEN_CHANNEL_LIST__SUBTITLE__IMG_UPLOAD": "Télécharger",
  "CREATE_OPEN_CHANNEL_LIST__SUBTITLE__TEXT_SECTION": "Nom de la conversation",
  "CREATE_OPEN_CHANNEL_LIST__SUBTITLE__TEXT_PLACE_HOLDER": "Entrer un nom de conversation",
  "CREATE_OPEN_CHANNEL_LIST__SUBMIT": "Créer",
  "OPEN_CHANNEL_SETTINGS__OPERATOR_TITLE": "Détails sur la conversation",
  "OPEN_CHANNEL_SETTINGS__OPERATOR_URL": "URL",
  "OPEN_CHANNEL_SETTINGS__PARTICIPANTS_ACCORDION_TITLE": "Participants",
  "OPEN_CHANNEL_SETTINGS__DELETE_CHANNEL_PANEL": "Supprimer la conversation",
  "OPEN_CHANNEL_SETTINGS__DELETE_CHANNEL_TITLE": "Supprimer la conversation ?",
  "OPEN_CHANNEL_SETTINGS__DELETE_CHANNEL_CONTEXT": "Une fois supprimée, cette conversation ne pourra pas être restaurée.",
  "OPEN_CHANNEL_SETTINGS__DELETE_CHANNEL_SUBMIT": "Supprimer.",
  "OPEN_CHANNEL_SETTINGS__OPERATORS_TITLE": "Opérateurs",
  "OPEN_CHANNEL_SETTINGS__OPERATORS__TITLE_ADD": "Ajouter un opérateur",
  "OPEN_CHANNEL_SETTINGS__OPERATORS__TITLE_ALL": "Tous les opérateurs",
  "OPEN_CHANNEL_SETTINGS__MUTED_MEMBERS__TITLE": "Participants mis en sourdine",
  "OPEN_CHANNEL_SETTINGS__MUTED_MEMBERS__TITLE_ALL": "Tous les participants mis en sourdine",
  "OPEN_CHANNEL_SETTINGS__MUTED_MEMBERS__NO_ONE": "Pas encore de participant mis en sourdine",
  "OPEN_CHANNEL_SETTINGS__BANNED_MEMBERS__TITLE": "Utilisateurs bannis",
  "OPEN_CHANNEL_SETTINGS__BANNED_MEMBERS__TITLE_ALL": "Tous les utilisateurs bannis",
  "OPEN_CHANNEL_SETTINGS__BANNED_MEMBERS__NO_ONE": "Pas encore d'utilisateur banni",
  "OPEN_CHANNEL_SETTINGS__MEMBERS__YOU": "(Vous)",
  "OPEN_CHANNEL_SETTINGS__MEMBERS__OPERATOR": "Opérateur",
  "OPEN_CHANNEL_SETTINGS__PARTICIPANTS_TITLE": "Participant",
  "OPEN_CHANNEL_SETTINGS__EMPTY_LIST": "Pas encore de participants",
  "OPEN_CHANNEL_SETTINGS__SEE_ALL": "Voir tous les participants",
  "OPEN_CHANNEL_SETTINGS__ALL_PARTICIPANTS_TITLE": "Tous les participants",
  "OPEN_CHANNEL_SETTINGS__NO_TITLE": "(Pas de titre)",
  "OPEN_CHANNEL_SETTING__MODERATION__REGISTER_AS_OPERATOR": "Enregistrer en tant qu'opérateur",
  "OPEN_CHANNEL_SETTING__MODERATION__UNREGISTER_OPERATOR": "Enlever en tant qu'opérateur",
  "OPEN_CHANNEL_SETTING__MODERATION__MUTE": "Mettre en sourdine",
  "OPEN_CHANNEL_SETTING__MODERATION__UNMUTE": "Ne plus mettre en sourdine",
  "OPEN_CHANNEL_SETTING__MODERATION__BAN": "Bannir",
  "OPEN_CHANNEL_SETTING__MODERATION__UNBAN": "Débannir",
  "TRYING_TO_CONNECT": "Connexion en cours...",
  "TYPING_INDICATOR__IS_TYPING": "est en train de taper...",
  "TYPING_INDICATOR__AND": "et",
  "TYPING_INDICATOR__ARE_TYPING": "sont en train de taper...",
  "TYPING_INDICATOR__MULTIPLE_TYPING": "Plusieurs personnes sont en train de taper...",
  "CHANNEL_FROZEN": "Conversation gelée",
  "PLACE_HOLDER__NO_CHANNEL": "Pas de conversations",
  "PLACE_HOLDER__WRONG": "Une erreur s'est produite",
  "PLACE_HOLDER__RETRY_TO_CONNECT": "Réessayer",
  "PLACE_HOLDER__NO_MESSAGES": "Pas de messages",
  "TOOLTIP__AND_YOU": ", et vous",
  "TOOLTIP__YOU": "vous",
  "TOOLTIP__UNKNOWN_USER": "(pas de nom)",
  "UNKNOWN__UNKNOWN_MESSAGE_TYPE": "(Type de message inconnu)",
  "UNKNOWN__CANNOT_READ_MESSAGE": "Impossible de lire ce message.",
  "MESSAGE_EDITED": "(modifié)",
  "MODAL__DELETE_MESSAGE__TITLE": "Supprimer ce message ?",
  "MODAL__CHANNEL_INFORMATION__TITLE": "Modifier les détails de la conversation",
  "MODAL__CHANNEL_INFORMATION__CHANNEL_IMAGE": "Photo de la conversation",
  "MODAL__CHANNEL_INFORMATION__UPLOAD": "Télécharger",
  "MODAL__CHANNEL_INFORMATION__CHANNEL_NAME": "Nom de la conversation",
  "MODAL__CHANNEL_INFORMATION__INPUT__PLACE_HOLDER": "Entrer un nom",
  "MODAL__INVITE_MEMBER__TITLE": "Inviter un membre",
  "MODAL__INVITE_MEMBER__SELECTED": "sélectionné",
  "MODAL__CHOOSE_CHANNEL_TYPE__TITLE": "Nouvelle conversation",
  "MODAL__CHOOSE_CHANNEL_TYPE__GROUP": "Groupe",
  "MODAL__CHOOSE_CHANNEL_TYPE__SUPER_GROUP": "Super groupe",
  "MODAL__CHOOSE_CHANNEL_TYPE__BROADCAST": "Annonce",
  "MODAL__CREATE_CHANNEL__TITLE": "Nouvelle conversation",
  "MODAL__CREATE_CHANNEL__GROUP": "Groupe",
  "MODAL__CREATE_CHANNEL__SUPER": "Super groupe",
  "MODAL__CREATE_CHANNEL__BROADCAST": "Annonce",
  "MODAL__CREATE_CHANNEL__SELECTED": "sélectionné",
  "MODAL__LEAVE_CHANNEL__TITLE": "Quitter cette conversation ?",
  "MODAL__LEAVE_CHANNEL__FOOTER": "Quitter",
  "MODAL__VOICE_MESSAGE_INPUT_DISABLED__TITLE_MUTED": "L'opérateur vous a mis en sourdine",
  "MODAL__VOICE_MESSAGE_INPUT_DISABLED__TITLE_FROZEN": "Conversation gelée.",
  "USER_PROFILE__MESSAGE": "Message",
  "USER_PROFILE__USER_ID": "User Id",
  "EDIT_PROFILE__TITLE": "Mon profil",
  "EDIT_PROFILE__IMAGE_LABEL": "Photo de profil",
  "EDIT_PROFILE__IMAGE_UPLOAD": "Télécharger",
  "EDIT_PROFILE__NICKNAME_LABEL": "Pseudonyme",
  "EDIT_PROFILE__NICKNAME_PLACEHOLDER": "Entrer votre pseudonyme",
  "EDIT_PROFILE__USERID_LABEL": "User ID",
  "EDIT_PROFILE__THEME_LABEL": "Thème sombre",
  "MESSAGE_INPUT__PLACE_HOLDER": "Entrer un message",
  "MESSAGE_INPUT__PLACE_HOLDER__DISABLED": "Il n'est pas possible d'envoyer des messages dans cette conversation",
  "MESSAGE_INPUT__PLACE_HOLDER__MUTED": "Vous ne pouvez pas envoyer de message dans cette conversation car vpus avez été mis en sourdine",
  "MESSAGE_INPUT__PLACE_HOLDER__MUTED_SHORT": "Vous avez été mis en sourdine",
  "MESSAGE_INPUT__QUOTE_REPLY__PLACE_HOLDER": "Répondre à ce message",
  "BUTTON__CANCEL": "Annuler",
  "BUTTON__DELETE": "Supprimer",
  "BUTTON__SAVE": "Sauvegarder",
  "BUTTON__CREATE": "Créer",
  "BUTTON__INVITE": "Inviter",
  "BUTTON__OK": "Valider",
  "BADGE__OVER": "+",
  "NO_TITLE": "Pas de titre",
  "NO_NAME": "(Pas de nom)",
  "NO_MEMBERS": "(Pas de membres)",
  "MESSAGE_MENU__COPY": "Copier",
  "MESSAGE_MENU__REPLY": "Répondre",
  "MESSAGE_MENU__THREAD": "Répondre dans le fil",
  "MESSAGE_MENU__OPEN_IN_CHANNEL": "Ouvrir dans la conversation",
  "MESSAGE_MENU__EDIT": "Modifier",
  "MESSAGE_MENU__RESEND": "Renvoyer",
  "MESSAGE_MENU__DELETE": "Supprimer",
  "MESSAGE_MENU__SAVE": "Sauvegarder",
  "SEARCH": "Rechercher",
  "SEARCH_IN_CHANNEL": "Rechercher dans la conversation",
  "SEARCH_IN": "Rechercher dans",
  "SEARCHING": "Recherche dans les messages en cours...",
  "NO_SEARCHED_MESSAGE": "Pas de résultats.",
  "QUOTE_MESSAGE_INPUT__REPLY_TO": "Répondre à",
  "QUOTE_MESSAGE_INPUT__FILE_TYPE_IMAGE": "Photo",
  "QUOTE_MESSAGE_INPUT__FILE_TYPE_GIF": "GIF",
  "QUOTE_MESSAGE_INPUT__FILE_TYPE__VIDEO": "Vidéo",
  "QUOTED_MESSAGE__REPLIED_TO": "a répondu à",
  "QUOTED_MESSAGE__CURRENT_USER": "Vous",
  "QUOTED_MESSAGE__UNAVAILABLE": "Message indisponible",
  "THREAD__HEADER_TITLE": "Fil",
  "CHANNEL__THREAD_REPLY": "réponse",
  "CHANNEL__THREAD_REPLIES": "réponses",
  "CHANNEL__THREAD_OVER_MAX": "99+",
  "THREAD__THREAD_REPLY": "réponse",
  "THREAD__THREAD_REPLIES": "réponses",
  "THREAD__INPUT__REPLY_TO_THREAD": "Répondre au fil",
  "THREAD__INPUT__REPLY_IN_THREAD": "Répondre dans le fil",
  "MENTION_NAME__NO_NAME": "(Pas de nom)",
  "MENTION_COUNT__OVER_LIMIT": "Impossible de faire plus de %d mentions par message.",
  "UI__FILE_VIEWER__UNSUPPORT": "Message non supporté",
  "VOICE_MESSAGE": "Message vocal"
}
